const datePerson = [{
  img: '0',
  numberQuestion: 3,
}, {
  img: '1',
  numberQuestion: 0,
}, {
  img: '2',
  numberQuestion: 0,
}, {
  img: '3',
  numberQuestion: 0,
}, {
  img: '4',
  numberQuestion: 0,
}, {
  img: '5',
  numberQuestion: 0,
}, {
  img: '6',
  numberQuestion: 0,
}, {
  img: '7',
  numberQuestion: 0,
}, {
  img: '8',
  numberQuestion: 0,
}, {
  img: '9',
  numberQuestion: 0,
}];

export default datePerson;
